/**
 * Helpful won't be updated after click.
 * when just the user clicked on helpful - update count
 * **/
export const updateReviewsHelpful = ({ reviews = [], helpfulMap = {} }) => {
    reviews.forEach((review) => {
        const helpful = helpfulMap[review.id];
        if (helpful && helpful.thumbUp) {
            review.helpful_count = Math.max(1, review.helpful_count || 0);
        }
    });
};
